declare global {
    interface Window {
        clarity?: ((...args: unknown[]) => void) & { q?: unknown[] }
    }
}

let msClarityScriptLoaded = false

export function loadMSClarity(projectId: string) {
    if (!projectId || msClarityScriptLoaded) {
        return
    }
    msClarityScriptLoaded = true
    const w = window as Window & { clarity?: ((...args: unknown[]) => void) & { q?: unknown[] } }
    const clarityFn = function (...args: unknown[]) {
        ;(clarityFn.q = clarityFn.q || []).push(args)
    } as ((...args: unknown[]) => void) & { q?: unknown[] }
    w.clarity = w.clarity || clarityFn
    const script = document.createElement('script')
    script.async = true
    script.src = 'https://www.clarity.ms/tag/' + projectId
    const firstScript = document.getElementsByTagName('script')[0]
    firstScript?.parentNode?.insertBefore(script, firstScript)
}

export function setMSClarityTag(key: string, value: string | undefined) {
    if (!value) {
        return
    }
    if (typeof window.clarity === 'function') {
        window.clarity('set', key, value)
    }
}
